const gestureValueToText = (val) => {
    if (val == 1) return 'Down'
    else if (val == 2) return 'Up'
    else if (val == 3) return 'Right'
    else if (val == 4) return 'Left'
    else return val
}

export { gestureValueToText }
